<template>
    <div class="MatchDetailFigure">
        <span v-if="getUrl(player) == ''">
            <span v-bind:style="{ 'background-image' : 'url(' + getImage(player) + ')' }"></span>
        </span>
        <a v-else :href="getUrl(player)" target="_blank">
            <span v-bind:style="{ 'background-image' : 'url(' + getImage(player) + ')' }"></span>
        </a>
    </div>
</template>

<script>
    export default {
        props: ['player','assoc'],
        data() {
            return {
                players : window.all_players,
            }
        },
        methods: {
            getImage(player) {

                let foundPlayer = this.findPlayerById(player)

                if (foundPlayer.featured_image && foundPlayer.featured_image.src)
                    return foundPlayer.featured_image.src

                if( foundPlayer.feed_image && foundPlayer.feed_image.length > 0 )
                    return foundPlayer.feed_image

                return window[this.assoc + '_default_image']

            },
            findPlayerById(playerId) {
                if ( playerId == '' )
                    return false

                let found = this.players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            getUrl(player){
                let foundPlayer = this.findPlayerById(player)

                if( foundPlayer && foundPlayer.bio_link )
                    return foundPlayer.bio_link

                return ''
            }
        }
    }
</script>
